import { render, staticRenderFns } from "./talent4.vue?vue&type=template&id=0f8b5102&scoped=true"
import script from "./talent4.vue?vue&type=script&lang=js"
export * from "./talent4.vue?vue&type=script&lang=js"
import style0 from "./talent4.vue?vue&type=style&index=0&id=0f8b5102&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8b5102",
  null
  
)

export default component.exports